import { SHEET_NAME as ACTION_TAKEN_ON_ISSUE_SHEET } from "./actionTakenOnIssueSheet";
import { SHEET_NAME as PUBLIC_POLICY_ADVOCATES_SHEET } from "./publicPolicyAdvocatesSheet";
import {
  SUBHEADER_FILL,
  TABLE_HEADER_FILL,
  addQuestionRow,
  addSectionHeader,
  addShortAnswerRow,
  internalSheetLink,
  mergeRow,
  safeText,
  setCell,
  setPrinciple5ColumnWidths,
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  COL_L,
  COL_M,
  COL_N,
} from "./principle6SheetHelpers";

const PRINCIPLE_TITLE =
  "Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent";

const AFFILIATION_ROW_COUNT = 10;

function hasAffiliationData(item) {
  return Boolean(String(item?.name || "").trim() || String(item?.reach || "").trim());
}

function getAffiliationRows(list, count) {
  const rows = Array.isArray(list) ? list : [];
  const limit = Math.min(AFFILIATION_ROW_COUNT, Math.max(0, Number(count) || 0));

  if (limit > 0) {
    return Array.from({ length: limit }, (_, index) => rows[index] || {});
  }

  return rows.filter(hasAffiliationData);
}

function addAffiliationsTable(ws, row, affiliations, affiliationCount) {
  row = addQuestionRow(
    ws,
    row,
    "1. (b) List the top 10 trade and industry chambers/ associations (determined based on the total members of such body) the entity is a member of / affiliated to.",
    "",
    { fullWidth: true }
  );

  setCell(ws, row, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, row, COL_E, COL_K, "Name of the trade and industry chambers / associations", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  mergeRow(
    ws,
    row,
    COL_L,
    COL_N,
    "Reach of trade and industry chambers / associations (State/National)",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  row += 1;

  getAffiliationRows(affiliations, affiliationCount).forEach((item, idx) => {
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    mergeRow(ws, row, COL_E, COL_K, safeText(item?.name, ""), { align: "left" });
    mergeRow(ws, row, COL_L, COL_N, safeText(item?.reach, ""), { align: "left" });
    row += 1;
  });

  return row;
}

export function buildPrinciple7Sheet(workbook, sectionC) {
  const ws = workbook.addWorksheet("PRINCIPLE 7", { views: [{ showGridLines: true }] });
  setPrinciple5ColumnWidths(ws);

  const principle = sectionC?.principle7 || {};
  const essential = principle?.essentialIndicators || {};
  const leadership = principle?.leadershipIndicator || {};

  let row = 3;
  row = addSectionHeader(ws, row, `PRINCIPLE 7: ${PRINCIPLE_TITLE}`);
  row = addSectionHeader(ws, row, "Essential Indicators", SUBHEADER_FILL);

  row = addShortAnswerRow(
    ws,
    row,
    "1. (a) Number of affiliations with trade and industry chambers/ associations.",
    safeText(essential?.numberOfAffiliationsWithTrade)
  );
  row = addAffiliationsTable(
    ws,
    row,
    essential?.listOf10TradeandIndustry,
    essential?.numberOfAffiliationsWithTrade
  );

  row = addQuestionRow(
    ws,
    row,
    "2. Provide details of corrective action taken or underway on any issues related to anti- competitive conduct by the entity, based on adverse orders from regulatory authorities.",
    "Show Detail",
    {
      link: internalSheetLink(ACTION_TAKEN_ON_ISSUE_SHEET),
      valueAlign: "center",
      valueVertical: "middle",
    }
  );

  row = addSectionHeader(ws, row, "Leadership Indicators", SUBHEADER_FILL);

  row = addQuestionRow(
    ws,
    row,
    "1. Details of public policy positions advocated by the entity:",
    "Show Detail",
    {
      link: internalSheetLink(PUBLIC_POLICY_ADVOCATES_SHEET),
      valueAlign: "center",
      valueVertical: "middle",
    }
  );

  return ws;
}
